import { format } from 'date-fns';
import dateFnsLocaleEs from 'date-fns/locale/es';
import { jsx as _jsx } from "react/jsx-runtime";
var formatDate = function formatDate(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PPP';
  return format(date, fmt, {
    locale: dateFnsLocaleEs
  });
};
export var useDateInputLabel = function useDateInputLabel(_ref) {
  var selected = _ref.selected,
    placeholder = _ref.placeholder,
    onMaskValue = _ref.onMaskValue,
    mode = _ref.mode;
  var placeholderJsx = /*#__PURE__*/_jsx("span", {
    className: "tw-text-neutral-light-500",
    children: placeholder || '00/00/00 - 00/00/00'
  });
  if (!selected) {
    return placeholderJsx;
  }

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (onMaskValue) return onMaskValue(selected);
  if (mode === 'single') {
    return formatDate(selected);
  }
  var _ref2 = selected,
    from = _ref2.from,
    to = _ref2.to;
  var rangeFmt = 'dd/MM/y';
  if (from && to) {
    return "".concat(formatDate(from, rangeFmt), " - ").concat(formatDate(to, rangeFmt));
  }
  if (from) {
    return "".concat(formatDate(from, rangeFmt));
  }
  return placeholderJsx;
};